module.exports = __webpack_public_path__ + "assets/img/eleventh_four.aa0b2828.jpg";